import _jsx from "@babel/runtime/helpers/jsx";
var _Website;
import React from 'react';
import PropTypes from 'prop-types';
import Website from '../Website';
import getData from './getData';
function FAQPage(_ref) {
  let {
    content
  } = _ref;
  const FAQSchemaStructureString = JSON.stringify(getData(content));
  return /*#__PURE__*/React.createElement(React.Fragment, null, _Website || (_Website = /*#__PURE__*/_jsx(Website, {})), /*#__PURE__*/_jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: FAQSchemaStructureString
    } /* eslint-disable-line */
  }));
}
export default FAQPage;